import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
export var getBackdropOverride = function getBackdropOverride() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: rgba(5, 5, 5, 0.7);\n"])));
};